<div class="form-row mr-bottom-16 form-container" [formGroup]="privatePersonFormGroup">
  <div class="form-col form-col-2">
    <np-phone-input
      [isValid]="privatePersonFormGroup.controls.phone.valid"
      formControlName="phone"
      placeholder="Телефон"
      [formControlParent]="privatePersonFormGroup.get('phone')"
      (change)="onChangePhone($event)"
      [readonly]="disablePhoneInput">
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(phoneControl, phoneErrors) }}
      </mat-error>
    </np-phone-input>
  </div>
  <div class="form-col form-col-2">
    <mat-form-field class="mat-block">
      <input type="text" placeholder="Прізвище" #lastNameInput
             class="text-capitalize"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             capitalizeWithDash
             formControlName="lastName" matInput [matAutocomplete]="auto"
             [errorStateMatcher]="matcher">
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="setContactFromCatalog($event)">
        <mat-option *ngFor="let option of catalogOptions" [value]="option">
          <div class="option-field option-field_sm">
            <div class="option-field__hint">{{option.Description}}</div>
            <div class="option-field__text">{{option.LastName}} {{option.FirstName}} {{option.MiddleName}}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(lastNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>

  </div>
  <div class="form-col form-col-2">
    <mat-form-field class="mat-block">
      <input matInput placeholder="Ім’я"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             capitalizeWithDash
             class="text-capitalize"
             formControlName="firstName"
             [errorStateMatcher]="matcher">
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(firstNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="form-col form-col-2 box-with-controls" [ngClass]="{'last-col' : IsEnabledCancel}">
    <mat-form-field class="mat-block">
      <input matInput placeholder="По батькові"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             capitalizeWithDash
             class="text-capitalize"
             formControlName="middleName"
             [errorStateMatcher]="matcher">
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(middleNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>
    <div class="control-icons" *ngIf="IsEnabledCancel">
      <div class="control-icons__item">
        <button mat-icon-button
                type="button"
                (click)="cancel()">
          <mat-icon class="material-icons_grey">
            cancel
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
